import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LangProvider } from "@/i18n";
import { Header } from "@/components/site/Header";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Footer } from "@/components/site/Contact";
import Home from "@/pages/Home";
import KundaliPage from "@/pages/Kundali";
import MilanPage from "@/pages/Milan";
import PanchangPage from "@/pages/Panchang";
import BookPage from "@/pages/Book";
import AdminPage from "@/pages/Admin";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.__lenis?.scrollTo(0, { immediate: true }); window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
};

function App() {
  useLenis();
  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollTop />
        <div className="site grain">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kundali" element={<KundaliPage />} />
              <Route path="/milan" element={<MilanPage />} />
              <Route path="/panchang" element={<PanchangPage />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
